import { RiArrowLeftLine, RiSearchLine } from '@remixicon/react';
import { Button, TextInput } from '@tremor/react';
import { VacanciesList } from './Vacancies/VacanciesList';
import { useMemo, useState } from 'react';
import Fuse from 'fuse.js';
import CreateNewVacancy from './Vacancies/CreateVacancy';
import { useQuery } from 'react-query';
import { getVacancies, Vacancy } from '../../../network/ats';

export const YourVacancies = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showCreateMenu, setShowCreateMenu] = useState(false);

  const showCreateMenuFunc = () => {
    setShowCreateMenu(true);
  };

  const {
    data: vacancies = [],
    isLoading,
    isError,
  } = useQuery({ queryKey: ['vacancies'], queryFn: getVacancies });

  const fuse = useMemo(
    () =>
      new Fuse(vacancies, {
        keys: ['jobTitle', 'description', 'jobLocation', 'jobType', 'department'],
        threshold: 0.3,
      }),
    [vacancies],
  );

  const filteredVacancies: Vacancy[] = useMemo(() => {
    if (!searchTerm) return vacancies;
    return fuse.search(searchTerm).map((result) => result.item);
  }, [searchTerm, fuse, vacancies]);

  return (
    <>
      {showCreateMenu ? (
        <div>
          <Button
            icon={RiArrowLeftLine}
            onClick={() => setShowCreateMenu(false)}
            className="mb-4 border-gray-300 bg-white text-gray-900"
            iconPosition="left"
            variant="secondary"
          >
            Back to Page
          </Button>
          <CreateNewVacancy />
        </div>
      ) : (
        <div className="rounded-xl bg-white shadow">
          <div className="flex flex-col gap-4 px-6 py-5 md:flex-row md:items-center md:justify-between">
            <div>
              <div className="text-lg font-semibold text-gray-900">
                Your vacancies
              </div>
              <div className="text-sm font-normal text-gray-600">
                All jobs you have published
              </div>
            </div>

            <div className="flex flex-row gap-4">
              <TextInput
                icon={RiSearchLine}
                placeholder="Search..."
                className="w-auto lg:w-[400px]"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button
                className=" rounded-lg bg-red-500 px-4 py-2.5 font-semibold text-white"
                onClick={showCreateMenuFunc}
              >
                Create Vacancy
              </button>
            </div>
          </div>
          <div className="h-[1px] !min-w-full bg-gray-300 p-0"></div>
          <div>
            {isLoading ? (
              <div className="flex h-40 w-full items-center justify-center text-gray-500">
                Loading vacancies…
              </div>
            ) : isError ? (
              <div
                role="alert"
                className="flex h-40 w-full items-center justify-center text-red-600"
              >
                Vacancies could not be loaded. Please refresh the page.
              </div>
            ) : filteredVacancies.length === 0 ? (
              <div className="flex h-80 w-full items-center justify-center text-xl font-bold text-gray-900">
                No vacancies were found
              </div>
            ) : (
              <VacanciesList vacancies={filteredVacancies} />
            )}
          </div>
        </div>
      )}
    </>
  );
};
